const errorsToWarn: string[] = ['Warning:'];

/**
 * After migrating to React 18 our console logs became flooded with errors that are actually warnings.
 * This patch is used to warn instead of error.
 */
const consoleErrorsPatch = () => {
  const oldConsError = console.error;
  console.error = function (...args: any) {
    let toWarn: boolean = false;

    if (typeof args[0] === 'string') {
      errorsToWarn.forEach((_s: string) => {
        if (args[0].startsWith(_s)) {
          toWarn = true;
        }
      });
    }

    if (toWarn) {
      console.warn(...args);
    } else {
      oldConsError(...args);
    }
  };
};

export default consoleErrorsPatch;
